import "./Atoms.scss";

interface Props {
  text: string;
}

export const Error = (props: Props) => (
  <span className="validation-error">{props.text}</span>
);
